import React from 'react'
import './services.css'
import {BiCheck} from 'react-icons/bi'

const Services = () => {
  return (
    <section id='services'>
      <h5>What I Offer</h5>
      <h2>Services</h2>

      <div className="container services_container">
        <article className="service">
          <div className="service_head">
            <h3>UI/UX Design</h3>
          </div>

          <ul className='service_list'>
            <li>
              <BiCheck className='service_list-icons' />
              <p>Aesthetic Perception</p>
            </li>

            <li>
              <BiCheck className='service_list-icons' />
              <p>User Engagement</p>
            </li>

            <li>
              <BiCheck className='service_list-icons' />
              <p>Creativity</p>
            </li>

            <li>
              <BiCheck className='service_list-icons' />
              <p>Consistancy</p>
            </li>

            <li>
              <BiCheck className='service_list-icons' />
              <p>User-friendly</p>
            </li>
          </ul>
        </article>
        {/* END OF UI/UX */}

        <article className="service">
          <div className="service_head">
            <h3>Web Development</h3>
          </div>

          <ul className='service_list'>
            <li>
              <BiCheck className='service_list-icons' />
              <p>Efficient Code Writing</p>
            </li>

            <li>
              <BiCheck className='service_list-icons' />
              <p>Religious Code Writing</p>
            </li>

            <li>
              <BiCheck className='service_list-icons' />
              <p>Advantaged Thinking</p>
            </li>

            <li>
              <BiCheck className='service_list-icons' />
              <p>Self-motivation</p>
            </li>

            <li>
              <BiCheck className='service_list-icons' />
              <p>Well Teamwork Player</p>
            </li>
          </ul>
        </article>
        {/* END OF WEB DEVELOPMENT */}

        <article className="service">
          <div className="service_head">
            <h3>Skills</h3>
          </div>

          <ul className='service_list'>
            <li>
              <BiCheck className='service_list-icons' />
              <p>Strong Customer Service</p>
            </li>

            <li>
              <BiCheck className='service_list-icons' />
              <p>Well Communication</p>
            </li>

            <li>
              <BiCheck className='service_list-icons' />
              <p>Diligence</p>
            </li>

            <li>
              <BiCheck className='service_list-icons' />
              <p>Initiative</p>
            </li>

            <li>
              <BiCheck className='service_list-icons' />
              <p>Problem-solving</p>
            </li>
          </ul>
        </article>
        {/* END OF CONTENT CREATION */}





      </div>
    </section>
  )
}

export default Services